/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 10b70efd47036b72e8d1dec5d12405f81f712e3a
 */

/**
 * What a row of a royalty export is: one invoice line, or one day behind it.
 */
export type RoyaltyExportGranularity = typeof RoyaltyExportGranularity[keyof typeof RoyaltyExportGranularity];


export const RoyaltyExportGranularity = {
  daily: 'daily',
  monthly: 'monthly',
} as const;
